import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const View = styled.button`
    padding: 12px 24px;
    border: none;
    border-radius: 0;
    background-color: #4a4a4a;
    color: #fff;
    font-size: 14px;
    text-transform: uppercase;
    cursor: pointer;

    &:hover {
        opacity: 0.9;
    }

    &:focus {
        outline: none;
    }

    .fl & {
        font-family: 'Open Sans', sans-serif;
    }
`;

const Button = props => {
    return (
        <View onClick={props.onClick} className={props.className}>
            {props.label}
        </View>
    );
};

Button.defaultProps = {
    onClick: () => {},
};

Button.propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/shared/Button.js